// extracted by mini-css-extract-plugin
export var formField = "styles-module__formField___ZBtl0";
export var form = "styles-module__form___syWMq";
export var formDateActivity = "styles-module__formDateActivity___wV7bi";
export var dateSelect = "styles-module__dateSelect___v6DHA";
export var privacyTrigger = "styles-module__privacyTrigger___jwvWC";
export var dateBlock = "styles-module__dateBlock___ULI93";
export var dateLabel = "styles-module__dateLabel___USeY8";